import dayjs, { Dayjs } from 'dayjs'
import z from 'zod'

export const zodPassword = z
    .string()
    .regex(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/,
        'Password must be at least 8 characters long, include at least one digit, and contain at least one special character'
    )

export const DayjsSchema = z.custom<Dayjs>(
    (val) => dayjs.isDayjs(val),
    'Invalid Date'
)

export const dbString = z.string().nullable().default(null)
export const dbNumber = z.number().nullable().default(null)
export const dbBoolean = z.boolean().nullable().default(null)
export const dbBooleanMap = z
    .record(z.string(), z.boolean())
    .nullable()
    .default(null)

export const FileUploadSchema = z.union([
    z.string().min(2),
    z.file().mime(['image/png', 'image/jpeg', 'application/pdf']),
])

export const FileSchema = FileUploadSchema.nullable().default(null)
